import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import * as cloneDeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import { Moment } from 'moment';
import { combineLatest } from 'rxjs';
import {
  ClickAndNavigationService,
  CommonService,
  EnergyService,
  PlantServiceService,
  SiteService,
  UtilitiesService
} from 'src/app/services/index';
import {
  AppUtils,
  Constants,
  DateService,
  Highcharts$,
  Moment$
} from 'src/app/shared/index';
import * as ObjectUtils from 'util';
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@Component({
  selector: 'app-over-view',
  templateUrl: './over-view.component.html',
  styleUrls: ['./over-view.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class OverViewComponent implements OnInit, AfterViewInit {
  formData: FormGroup;
  dateRange: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [Moment$().subtract(1, 'days'), Moment$().subtract(1, 'days')],
    'Last 7 Days': [Moment$().subtract(6, 'days'), Moment$()],
    'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    'This Month': [Moment$().startOf('month'), Moment$().endOf('month')]
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  totalEnergyCunsumptionHCChart: Chart;
  totalEnergyCostHCChart: Chart;
  totalEnergyCunsumptionHCChart_Test: Chart;
  totalEnergyCunsumptionHCChart_Test_1: Chart;
  costBreakupHCChart: Chart;
  totalCostBreakupHCChart: Chart;
  costBreakupHCChart_Test: Chart;
  kpiTrendsChart: Chart;
  totalEnergyChartOption: any;
  costBreakupOption: any;
  siteId: string;
  startDateStr: string;
  endDateStr: string;
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  isFirstLoaded = true;
  isDateChanged = false;
  generatedTimeMsg = '';
  querySiteId: object;
  colors = ['#26b24a', '#ffe400', '#39c0ff'];
  totalEnergyConsumptionValue = 'NA';
  firstShiftKwhValue = 'NA';
  secondShiftKwhValue = 'NA';
  nightShiftKwhValue = 'NA';
  totalBreakupCost = 'NA';
  firstShiftCost = 'NA';
  secondShiftCost = 'NA';
  nightShiftCost = 'NA';
  utilityConsumptionData = [];
  isPlantNavigationView = false;
  clickAndNavigateFeatureEnabled = false;
  siteDetail: any;
  fullNavigationImageURL: string;
  navigationImageData: any;
  carbonFootPrint: string;
  processName = 'Whole Plant';
  timeBaseRanges = ['Today', 'Weekly', 'Monthly', 'Yearly'];
  timeBase = 'Daily';
  activeAlerts = 0;
  processes: any;
  yesterdayString: String;
  kpiTrendData: any;
  isNotViewFull = true;
  buttons: any;
  isOnViewFull = false;
  max = new Date();
  startView = 'month';
  minView = 'day';
  hourWiseDataRequired = false;
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;
  displayWidget = false;
  widgetWidth: string;
  thousandSeparator: string;
  decimalSepartor: string;
  constructor(
    private energyService: EnergyService,
    private dateService: DateService,
    private plantService: PlantServiceService,
    private clickAndNavigationService: ClickAndNavigationService,
    private siteService: SiteService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.totalEnergyChartOption = this.getTotalEnergyChartOption();
    this.costBreakupOption = this.getCostBreakUpChartOption();
    this.totalEnergyCostHCChart = new Chart(this.totalEnergyChartOption);
    this.totalEnergyCunsumptionHCChart = new Chart(this.totalEnergyChartOption);

    this.totalCostBreakupHCChart = new Chart(this.costBreakupOption);
    this.costBreakupHCChart = new Chart(this.costBreakupOption);
    //
    this.yesterdayString = `Yesterday (${Moment$()
      .subtract(1, 'days')
      .format(Constants.MOMENT_DATE_FORMAT.DAY_FORMAT)})`;
    // Testing
    this.totalEnergyCunsumptionHCChart_Test = new Chart(
      this.totalEnergyChartOption
    );
    this.totalEnergyCunsumptionHCChart_Test_1 = new Chart(
      this.totalEnergyChartOption
    );
    this.costBreakupHCChart = new Chart(this.costBreakupOption);
    // Testing
    this.costBreakupHCChart_Test = new Chart(this.costBreakupOption);
    this.alwaysShowCalendars = true;
    this.dateRange = {
      startDate: '2020-03-01T07:01:39.547Z',
      endDate: '2020-03-15T07:01:39.547Z'
    };
    this.onTimeBaseChange();
  }

  ngOnInit() {
    this.isPlantNavigationView = false;
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      this.querySiteId = Object.assign({}, { siteId: this.siteId });
      this.displayWidget =
        this.siteId !== 'TATAThen625564' && this.siteId !== 'MicrBeng560166'
          ? true
          : false;
      this.widgetWidth =
        this.siteId === 'TATAThen625564' || this.siteId === 'MicrBeng560166'
          ? '100%'
          : '68%';
      this.transformDate();
      this.getSiteDetailInfo(this.siteId);
    });
  }
  chosenStartDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.year(normalizedYear.year());
    this.startDate.setValue(moment(ctrlValue).startOf('year'));
    // this.startDate.setValue(ctrlValue);
    datepicker.close();
    this.validateStartDate();
  }
  chosenStartDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.startDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
    this.validateStartDate();
  }
  chosenEndDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.year(normalizedYear.year());
    this.endDate.setValue(moment(ctrlValue).startOf('year'));
    // this.endDate.setValue(ctrlValue);
    datepicker.close();
    this.validateEndDate();
  }
  chosenEndDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.endDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
    this.validateEndDate();
  }
  transform(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  private transformDate = () => {
    this.startDateStr = this.transform(this.startDate);
    this.endDateStr = this.transform(this.endDate);
  };
  onTimeBaseChange(event?: any) {
    if (
      !this.commonService.isNullOrUndefined(event) &&
      !this.commonService.isNullOrUndefined(event.srcElement)
    ) {
      this.timeBase = event.srcElement.value;
    }

    switch (this.timeBase) {
      case 'Yearly': {
        this.startView = 'multi-year';
        this.minView = 'year';
        this.startDate = new FormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Monthly': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(moment().startOf('month'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Quarterly': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Weekly': {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(moment().startOf('week'));
        this.hourWiseDataRequired = false;
        break;
      }
      default: {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(moment().subtract(1, 'days'));
        this.hourWiseDataRequired = true;
        break;
      }
    }
    this.endDate = new FormControl(moment().subtract(1, 'days'));
    this.validateStartDate();
  }
  getSiteDetailInfo(siteId) {
    this.plantService.getSiteDetail(siteId).subscribe((data) => {
      this.siteDetail = data;
      if (data.attachments !== undefined) {
        const url = this.commonService.getPlantLayoutUrl(this.siteId);
        this.utilitiesService.displayPlantLayout(url);
      }
      localStorage.setItem('siteTimezone', this.siteDetail.timezone);
      this.thousandSeparator = AppUtils.getThousandSeparator(
        Constants.LOCALE[this.siteDetail.timezone]
      );
      this.decimalSepartor = AppUtils.getDecimalSeparator(
        Constants.LOCALE[this.siteDetail.timezone]
      );

      this.processDataAndDrawChart();
      this.fetchUtilityConsumptionData();
      this.getProcessBySite();
    });
  }
  ngAfterViewInit() {
    const seft = this;
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    // document.addEventListener('resize', function () {
    window.onresize = function () {
      const dom = document.getElementById('chartContainer');
      if (seft.commonService.isNullOrUndefined(dom)) {
        return;
      }
      if (dom && dom.clientHeight > 400) {
        setTimeout(() => {
          dom.setAttribute('height', '400');
        }, 200);
      }
      if (document.fullscreenElement) {
        seft.kpiTrendsChart.ref.setSize(
          document.documentElement.clientWidth,
          document.documentElement.clientHeight
        );
      } else {
        seft.kpiTrendsChart.ref.setSize(
          dom.clientWidth,
          dom.clientHeight < 200 ? dom.clientHeight : 200
        );
      }
    };
    document.addEventListener('fullscreenchange', function () {
      seft.isOnViewFull = !seft.isOnViewFull;
      if (seft.kpiTrendsChart.ref) {
        seft.kpiTrendsChart.ref.reflow(new Event('resize'));
        seft.kpiTrendsChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      if (seft.kpiTrendsChart.ref) {
        seft.kpiTrendsChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }
  datesUpdated(event) {}
  public onChangeDateRange = () => {
    if (
      Moment$(this.dateRange.endDate).diff(
        Moment$(this.dateRange.startDate),
        'days'
      ) > 31
    ) {
      this.commonService.showDialogMessage(
        'Note: Data display limited to 31 days. Please select duration not more than 31 days'
      );
      return;
    }
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    if (
      this.isFirstLoaded === false &&
      ObjectUtils.isNullOrUndefined(this.siteId) === false
    ) {
      this.processDataAndDrawChart();
    }
  };
  private fetchUtilityConsumptionData = () => {
    this.siteService
      .fetchUtilityConsumptionInfo(
        this.siteId,
        this.startDateStr,
        this.endDateStr
      )
      .subscribe((data) => {
        if (ObjectUtils.isArray(data)) {
          data.forEach((item) => {
            if (item.consumption && item.consumption !== '-') {
              const tempConsumption = item.consumption.split(' ');
              const val = tempConsumption[0];
              const unit = ' ' + tempConsumption[1];
              item['consumptionValue'] = new Intl.NumberFormat(
                Constants.LOCALE[this.siteDetail.timezone],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+val);
              item['consumptionUnit'] = unit;
            }
            if (item.cost && item.cost !== '-') {
              const tempCost = item.cost.split(' ');
              const val = tempCost[0];
              const unit = ' ' + tempCost[1];
              item['costValue'] = new Intl.NumberFormat(
                Constants.LOCALE[this.siteDetail.timezone],
                {
                  style: 'currency',
                  currency: this.siteDetail.currency
                }
              ).format(+val);
              item['costUnit'] = unit;
            }
          });
          this.utilityConsumptionData = data;
        }
      });
  };
  private getProcessBySite() {
    this.siteService.getProcessBySiteId(this.siteId).subscribe((data) => {
      this.processes = data;
    });
  }
  private GetCo2Footprint = () => {
    const params = {
      siteId: this.siteId,
      processName: this.processName,
      timeBase: this.timeBase,
      startDate: this.startDateStr,
      endDate: this.endDateStr
    };
    this.siteService.getCarbonFootPrint(params).subscribe((data) => {
      if (data) {
        this.carbonFootPrint = new Intl.NumberFormat(
          Constants.LOCALE[this.siteDetail.timezone],
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(data);
      }
      if (data == 0) {
        this.carbonFootPrint = '0';
      }
    });
  };
  private getKPITrends = () => {
    const opt = this.getProcessEnergyChartOption();
    this.siteService
      .getKPITrendsChart(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        // if (data !== undefined && ObjectUtils.isArray(data.result)) {
        if (data !== undefined) {
          //   const grouped = this.groupBy(data.result, item => item.processName);
          const result = [];
          // if (grouped !== undefined) {
          //   grouped.forEach(element => {
          //     const cost = element.map(x => parseFloat(x.cost));
          //     result.push({ name: element[0].misService, data: cost });
          //   });
          //
          const dateArr = [];
          const holdArr = [];
          for (let i = 0; i < data.XAxisArray.length; i++) {
            dateArr.push(data.XAxisArray[i]);
          }

          for (let i = 0; i < data.servicesAndValues.length; i++) {
            let newArr = [];
            for (let j = 0; j < data.servicesAndValues[i].values.length; j++) {
              newArr.push(parseFloat(data.servicesAndValues[i].values[j]));
            }

            holdArr.push({
              name: data.servicesAndValues[i].service,
              data: newArr
            });
            newArr = [];
          }

          for (let j = 0; j < holdArr.length; j++) {
            result.push({
              name: holdArr[j].name,
              data: holdArr[j].data
            });
          }

          //     var arrK=[];
          //     var nameArr=["Energy"];
          //      for (var i=0;i<nameArr.length;i++)
          //      {
          //       arrK.push({
          //       name : nameArr[i],
          //       data: [50089.8,16962.4]
          //     })
          //  }
          //   // result.push({ name : "Energy", data: [15000,5000,0]});
          //    for( var j=0;j<arrK.length;j++)
          //    {
          //     result.push({
          //       name:arrK[j].name,
          //       data:arrK[j].data

          //     });
          //    }

          //  const categories = data.result.map(x => x.processName);

          opt.xAxis.categories = dateArr;

          opt.series = result;
          // console.log("the result is-->" + JSON.stringify(result));
          this.kpiTrendsChart = new Chart(<any>opt);
        }
      });
  };
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  private processDataAndDrawChart = () => {
    this.transformDate();

    this.isFirstLoaded = false;
    this.siteService
      .getConsumptionBreakUp(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        const chartData = [];
        let total = 0;
        if (data.data !== undefined) {
          for (let i = 0; i < data.data.length; i++) {
            total += data.data[i];
            chartData.push([data.categories[i], data.data[i]]);
          }
          if (data.data.length === 3) {
            this.firstShiftKwhValue = data.data[0] + ' kWh';
            this.secondShiftKwhValue = data.data[1] + ' kWh';
            this.nightShiftKwhValue = data.data[2] + ' kWh';
          }
        }

        this.totalEnergyConsumptionValue =
          Highcharts$.numberFormat(
            total,
            Constants.DECIMAL_FORMAT.SOLAR_DECIMAL_NO
          ) + ' kWh';

        this.totalEnergyChartOption = this.getTotalEnergyChartOption();
        this.totalEnergyChartOption.series[0].data = chartData;
        this.totalEnergyCostHCChart = new Chart(this.totalEnergyChartOption);
        this.totalEnergyCunsumptionHCChart = new Chart(
          this.totalEnergyChartOption
        );
        // Testing
        const optionsTest = cloneDeep(this.totalEnergyChartOption);
        optionsTest.plotOptions.pie.showInLegend = false;
        this.totalEnergyCunsumptionHCChart_Test = new Chart(optionsTest);
        this.totalEnergyCunsumptionHCChart_Test_1 = new Chart(optionsTest);
      });

    this.siteService
      .getCostBreakUp(this.siteId, this.startDateStr, this.endDateStr)
      .subscribe((data) => {
        const chartData = [];
        let total = 0;
        if (data.data !== undefined) {
          for (let i = 0; i < data.data.length; i++) {
            total += data.data[i];
            chartData.push([data.categories[i], data.data[i]]);
          }
          if (data.data.length === 3) {
            this.firstShiftCost = data.data[0] + 'INR';
            this.secondShiftCost = data.data[1] + 'INR';
            this.nightShiftCost = data.data[2] + 'INR';
          }
        }

        this.totalBreakupCost =
          Highcharts$.numberFormat(
            total,
            Constants.DECIMAL_FORMAT.SOLAR_DECIMAL_NO
          ) + ' INR';

        this.costBreakupOption = this.getCostBreakUpChartOption();
        this.costBreakupOption.series[0].data = chartData;
        this.totalCostBreakupHCChart = new Chart(this.costBreakupOption);
        this.costBreakupHCChart = new Chart(this.costBreakupOption);
      });

    this.plantService.getShiftsBySiteId(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        const firstShiftStart = data[0].shiftStart;
        const lastShiftEnd = data[data.length - 1].shiftEnd;
        const dayRange = Moment$(this.endDate.value).diff(
          Moment$(this.startDate.value),
          'days'
        );
        let newDate = Moment$();
        if (dayRange === 0) {
          newDate = Moment$(this.endDate.value).add(1, 'days');
        } else {
          newDate = Moment$(this.endDate.value);
        }
        this.generatedTimeMsg = `You are viewing data from
        ${Moment$(this.startDate.value).format(
          Constants.MOMENT_DATE_FORMAT.DAY_FORMAT
        )}
        ${Moment$(firstShiftStart).format(
          Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
        )}
        to ${Moment$(newDate).format(Constants.MOMENT_DATE_FORMAT.DAY_FORMAT)}
        ${Moment$(lastShiftEnd).format(
          Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
        )}`;
      }
    });
    this.GetCo2Footprint();
    this.fetchUtilityConsumptionData();
    this.getKPITrends();
    this.siteService.getActiveAlertsOfSite(this.siteId).subscribe((data) => {
      if (data > 0) {
        this.activeAlerts = data;
      }
    });
  };
  // New REQ
  private getTotalEnergyChartOption = () => {
    const self = this;
    let timezone = '';
    if (self.siteDetail && self.siteDetail.timezone !== undefined) {
      timezone = self.siteDetail.timezone;
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });

    const option = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.point.name +
            '</b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ':<b> ' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(+this.y) +
            ' kWh (' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(+this.percentage) +
            ' %)</b>'
          );
        }
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -20,
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return (
                new Intl.NumberFormat(Constants.LOCALE[timezone], {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(+this.point.percentage) + ' %'
              );
              // return Highcharts$.numberFormat(this.y, Constants.DECIMAL_FORMAT.DECIMAL_NO);
            }
          },
          startAngle: -180,
          endAngle: 180,
          // center: ['50%', '75%'],
          size: '100%',
          showInLegend: true
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      // colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
      colors: this.colors,
      legend: {
        // layout: 'vertical',
        align: 'center',
        verticalAlign: 'bottom'
        // itemMarginTop: 10,
        // itemMarginBottom: 10
      },
      series: [
        {
          type: 'pie',
          name: 'Energy',
          innerSize: '60%',
          data: []
        }
      ]
    };
    return option;
  };
  // Cost BreakUp
  private getCostBreakUpChartOption = () => {
    const self = this;
    let timezone = '';
    let currency = '';
    if (self.siteDetail && self.siteDetail.timezone !== undefined) {
      timezone = self.siteDetail.timezone;
    }
    if (self.siteDetail && self.siteDetail.currency !== undefined) {
      currency = self.siteDetail.currency;
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });

    const option = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.point.name +
            '</b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ':<b> ' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              style: 'currency',
              currency: currency
            }).format(+this.y) +
            ' (' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(+this.percentage) +
            ' %)</b>'
          );
        }
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -20,
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return (
                new Intl.NumberFormat(Constants.LOCALE[timezone], {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(+this.point.percentage) + ' %'
              );
            }
          },
          startAngle: -180,
          endAngle: 180,
          // center: ['50%', '75%'],
          size: '100%',
          showInLegend: true
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      // colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
      colors: this.colors,
      legend: {
        // layout: 'vertical',
        align: 'center',
        verticalAlign: 'bottom'
        // itemMarginTop: 10,
        // itemMarginBottom: 10
      },
      series: [
        {
          type: 'pie',
          name: 'Energy',
          innerSize: '60%',
          data: []
        }
      ]
    };
    return option;
  };
  private getProcessEnergyChartOption = () => {
    const self = this;

    let timezone = '';
    let currency = '';
    if (self.siteDetail && self.siteDetail.timezone !== undefined) {
      timezone = self.siteDetail.timezone;
    }
    if (self.siteDetail && self.siteDetail.currency !== undefined) {
      currency = self.siteDetail.currency;
    }

    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });

    const option = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      xAxis: {
        // type: 'category',
        // categories: ['1kWh', '2kWh', '3kWh', '4kWh', '5kWh', '6kWh']
        categories: []
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(Constants.LOCALE[timezone], {
              style: 'currency',
              currency: currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(+this.value);
          }
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: 'gray'
          },
          formatter: function () {
            //   return Highcharts$.numberFormat(this.axis.series[0].yData[this.x], Constants.DECIMAL_FORMAT.DECIMAL_NO) + ' INR';
          }
        }
      },
      // legend : {
      //   align : 'center',
      //   verticalAlign : 'bottom',
      //   floating : true,
      //   backgroundColor : 'white',
      //   borderColor : '#CCC',
      //   borderWidth : 1,
      //   shadow : false
      // },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
            color: 'grey',
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return new Intl.NumberFormat(Constants.LOCALE[timezone], {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(+this.y);
            }
          }
        }
      },
      tooltip: {
        formatter: function () {
          let dataSum = 0;
          const seriesData = this.series.data;
          for (let i = 0; i < seriesData.length; i++) {
            dataSum += seriesData[i].y;
          }
          const pcnt = (this.y / dataSum) * 100;

          // tslint:disable-next-line:max-line-length
          return (
            '<b>' +
            this.key +
            '</b><br/>' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(+pcnt) +
            ' %<br/>' +
            new Intl.NumberFormat(Constants.LOCALE[timezone], {
              style: 'currency',
              currency: currency
            }).format(+this.y)
          );
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: ''
        }
      ]
    };
    return option;
  };
  public onPlantVirtualNavigationClick = () => {
    // this.isPlantNavigationView = true;
    this.router.navigate(['/site/plant-navigation'], {
      queryParams: { siteId: this.siteId }
    });
  };
  viewFault() {
    this.router.navigate(['/site/energy-dashboard', 'notifications'], {
      queryParams: { siteId: this.siteId }
    });
  }

  validateStartDate() {
    this.isValidEndDate = true;
    this.endDate.setErrors(null);
    var one_day = 1000 * 60 * 60 * 24;
    if (!this.startDate.invalid) {
      const fromDate = new Date(this.transform(this.startDate));
      const toDate = new Date(this.transform(this.endDate));

      if (fromDate > toDate) {
        this.isValidStartDate = false;
        this.startDateErrorMessage =
          'End date must be equal or greater than start date.';
        this.startDate.setErrors({ invalidDate: true });
        return;
      }
      // if (Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31) {
      //   this.isValidStartDate = false;
      //   this.startDateErrorMessage = 'Greater than 31 days is not allowed.';
      //   this.startDate.setErrors({ invalidDate: true });
      //   return;
      // }

      this.isValidStartDate = true;
      this.isValidEndDate = true;
      this.processDataAndDrawChart();
      const error = this.startDate.getError('invalidDate');
      if (error) {
        this.startDate.setErrors(null);
      }
    } else {
      this.startDateErrorMessage = 'Invalid date.';
    }
  }
  validateEndDate() {
    this.isValidEndDate = true;
    this.isValidStartDate = true;
    this.startDate.setErrors(null);
    var one_day = 1000 * 60 * 60 * 24;
    if (!this.endDate.invalid) {
      const fromDate = new Date(this.transform(this.startDate));
      const toDate = new Date(this.transform(this.endDate));

      if (fromDate > toDate) {
        this.isValidEndDate = false;
        this.endDateErrorMessage =
          'End date must be equal or greater than start date.';
        this.endDate.setErrors({ invalidDate: true });
        return;
      }
      if (Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31) {
        this.isValidEndDate = false;
        this.endDateErrorMessage = 'Greater than 31 days is not allowed.';
        this.endDate.setErrors({ invalidDate: true });
        return;
      }

      this.isValidEndDate = true;
      this.isValidStartDate = true;
      this.processDataAndDrawChart();
      const error = this.endDate.getError('invalidDate');
      if (error) {
        this.endDate.setErrors(null);
      }
    } else {
      this.endDateErrorMessage = 'Invalid date.';
    }
  }
  showTrend() {}
}
